import R from "ramda";

const styles = {
  padBtm0: {
    paddingBottom: "0",
  },
  online: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "green",
    margin: "0 5px",
  },
  offline: {
    display: "inline-block",
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: "red",
    margin: "0 5px",
  },
  maxW600: {
    marginRight: "auto",
    marginLeft: "auto",
    maxWidth: "500px",
  },
  pHeader: {
    // display: "inline-block",
    paddingLeft: "8px",
    borderLeft: "4px solid rgb(58, 127, 188)",
    color: "rgb(58, 127, 188)",
  },
  overflowY: { overflowY: "auto" },
  center: {
    display: "flex",
    justifyContent: "center",
  },
  relative: {
    position: "relative",
  },
  fullSize: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: "#fff",
  },
  mask: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  w400: {
    width: "400px",
  },
  transparent: {
    boxShadow: "none",
  },
  paddTop16: {
    "padding-top": "16px",
  },
  margBtm30: {
    marginBottom: "30px",
  },
  margBtm8: {
    marginBottom: "8px",
  },
  margLt5: {
    marginLeft: "5px",
  },
  margLt8: {
    marginLeft: "8px",
  },
  margBtm10: {
    marginBottom: "10px",
  },
  margBtm50: {
    marginBottom: "50px",
  },
  margRgt10: {
    marginRight: "10px",
  },
  wrapper: {
    padding: "16px",
  },
  rightWrapper: {
    padding: "0 0 8px 8px",
  },
  appWrapper: {
    padding: "8px",
    border: "1px solid #999",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "8px",
  },
  between: {
    justifyContent: "space-between",
  },
  body: {
    height: "calc(100% - 50px)",
  },
  list: {
    background: "#fff",
    border: "1px solid #e8e8e8",
    borderRadius: "4px",
    overflow: "auto",
    height: "100%",
  },
  collapse: { backgroundColor: "transparent" },
  collapsePanel: { background: "#fff", marginTop: "8px" },
  selectList: {
    background: "#edf8fc",
  },
  listItem: {
    padding: "8px 24px",
    cursor: "pointer",
  },
  pointer: {
    cursor: "pointer",
  },
  statusIcon: {
    position: "relative",
    top: "1px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
  },
};

type IstyleKey = keyof typeof styles | "";
type Iarg = IstyleKey | IstyleKey[];

const getStyles = (styles, ...args: Iarg[]) => {
  const pickNeededStyles = R.pick(R.__, styles);
  const mergeStyles = R.reduce(R.merge, {});
  return R.pipe(pickNeededStyles, R.values, mergeStyles)(args.flat(Infinity));
};

const getCustomStyles: (...args: Iarg[]) => any = R.partial(getStyles, [
  styles,
]);
export default getCustomStyles;
